import doc                        from '@widesk-core/decorators/doc';
import AbstractEventWorkflowModel from './AbstractEventWorkflowModel';
import { RenderNameProps }        from '@widesk-ui/mixins/ApiModelRenderName';

@doc.urnResource('event_workflow')
export default class EventWorkflowModel extends AbstractEventWorkflowModel {
	public get pagePathPrefix() {
		return `/configuration/${this.eventWorkflowType.reference}`;
	}

	public renderName(props?: RenderNameProps<this> & EventWorkflowNameProps) {
		return super.renderName(props);
	}
}
